const triggerRMOWebhook = async (bookingId) => {
    const myHeaders = new Headers();
    // myHeaders.append("Authorization", ""); // Add authorization if required

    const formdata = new FormData();
    formdata.append("Booking_id", bookingId);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };

    try {
        const response = await fetch(
            `${process.env.REACT_APP_N8N_WEBHOOK_BASE_URL}/RMOCasesTrigger`,
            requestOptions
        );
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.text();
        console.log("RMO Webhook Result:", result);
        return { success: true, data: result };
    } catch (error) {
        console.error("RMO Webhook Error:", error);
        throw error;
    }
};

export default triggerRMOWebhook;
